'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = modifiedStyles;

var _lodash = require('lodash.isfunction');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isobject');

var _lodash4 = _interopRequireDefault(_lodash3);

var _normalizeModifiers = require('./normalizeModifiers');

var _normalizeModifiers2 = _interopRequireDefault(_normalizeModifiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Extracts and builds the required style string based on the provided values.
 * @param {Array|String} modifierProps An array of strings or a single string
 *                                     that must match up with keys in modifierConfig
 * @param {Object} modifierConfig A modifierConfig object that defines the styles
 * @param {Object} componentProps The calling component's props, used when calling the
 *                                config definitions.
 */
function modifiedStyles() {
  var modifierProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var modifierConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var componentProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var stylesArr = (0, _normalizeModifiers2.default)(modifierProps).reduce(function (acc, modifierName) {
    var modifierFunc = modifierConfig[modifierName];
    if ((0, _lodash2.default)(modifierFunc)) {
      var config = modifierFunc(componentProps);
      var styles = (0, _lodash4.default)(config) ? config.styles : config;
      return acc.concat(styles);
    }
    return acc;
  }, []);

  return stylesArr.join(' ');
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/styled-components-modifiers/dist/utils/modifiedStyles.js
// module id = 697
// module chunks = 2